export const forRange = <T>(
  start: number,
  length: number,
  iterator: (idx: number) => T,
) => {
  const sum: T[] = [];
  for (let i = start; i < start + length; i++) {
    sum.push(iterator(i));
  }
  return sum;
};
